// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2q1BP","selects":"Documents_selects__3tgza"};